export default __webpack_public_path__ + "static/affiliate-program-PartnersAre-1-8a0ea7bcd6f8410eb9961beaec7894c1.svg";